/* Get Joy — nav launch pages + content module: toggles, sticky mini-header, analytics (Oct 2026). */
(function () {
  'use strict';
  if (window.__gjzpLoaded) return; window.__gjzpLoaded = true;
  var push = function (ev, d) { try { var o = { event: ev }; for (var k in d || {}) o[k] = d[k]; (window.dataLayer = window.dataLayer || []).push(o); } catch (e) {} };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  $$('.gjzp[data-gjzp-page]').forEach(function (root) {
    var page = root.getAttribute('data-gjzp-page');
    push(page + '_view', {});

    // timeline toggle (Auto-Ship)
    $$('[data-gjzp-tog]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-gjzp-tog');
        $$('[data-gjzp-tog]', root).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        $$('[data-gjzp-for]', root).forEach(function (p) { p.hidden = p.getAttribute('data-gjzp-for') !== k; });
        push(page + '_timeline', { product: k });
      });
    });

    // jump links
    $$('[data-gjzp-jump]', root).forEach(function (a) {
      a.addEventListener('click', function () { push(page + '_jump', { target: a.getAttribute('data-gjzp-jump') }); });
    });

    // FAQ opens
    $$('details[data-gjzp-faq]', root).forEach(function (d) {
      d.addEventListener('toggle', function () { if (d.open) push(page + '_faq_open', { q: d.getAttribute('data-gjzp-faq') }); });
    });

    // CTA / choose clicks
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-gjzp-ev]');
      if (!a) return;
      var d = {};
      if (a.hasAttribute('data-gjzp-pos')) d.pos = a.getAttribute('data-gjzp-pos');
      if (a.hasAttribute('data-gjzp-product')) d.product = a.getAttribute('data-gjzp-product');
      push(a.getAttribute('data-gjzp-ev'), d);
    });

    // compare: sticky mini header while the table is on screen
    var mini = root.querySelector('[data-gjzp-mini]'), table = root.querySelector('[data-gjzp-table]');
    if (mini && table && 'IntersectionObserver' in window) {
      var head = table.querySelector('thead');
      var vis = false, past = false;
      var upd = function () { mini.classList.toggle('is-on', vis && past); mini.setAttribute('aria-hidden', String(!(vis && past))); };
      new IntersectionObserver(function (en) { vis = en[0].isIntersecting; upd(); }, { rootMargin: '-80px 0px -40% 0px' }).observe(table);
      if (head) new IntersectionObserver(function (en) { past = !en[0].isIntersecting && en[0].boundingClientRect.top < 80; upd(); }, { rootMargin: '-72px 0px 0px 0px' }).observe(head);
    }
  });

  // content module views (inline + end)
  if ('IntersectionObserver' in window) {
    var seen = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (!x.isIntersecting) return;
        var el = x.target; seen.unobserve(el);
        push('content_module_view', { topic: el.getAttribute('data-topic'), position: el.getAttribute('data-position'), template: el.getAttribute('data-template') });
      });
    }, { threshold: .4 });
    $$('[data-gjzp-module]').forEach(function (el) { seen.observe(el); });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-gjzp-module] a, a[data-gjzp-module]');
    if (!a) return;
    var m = a.closest('[data-gjzp-module]') || a;
    push('content_cta_click', { topic: m.getAttribute('data-topic'), position: m.getAttribute('data-position'), dest: a.getAttribute('href') });
  });
})();
